import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { ResponsiveModule } from '@viablelogic/ngx-responsive';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { CourseTeaserComponent } from './course-teaser.component';

@NgModule({
    imports: [
        CommonModule,
        ResponsiveModule,
        DaButtonModule,
        DaLinkModule,
        DaProgressiveImageModule,
        RouterModule,
        LocalizeRouterModule,
        TranslateModule
    ],
    declarations: [CourseTeaserComponent],
    exports: [CourseTeaserComponent]
})
export class CourseTeaserModule {}
